import { isoToFormatDate } from "./formatTime";

const getMethodText = (history) => {
  const map = {
    POST: "新增",
    PUT: "修改",
    LOGIN: "登入",
    DELETE: "刪除",
  };

  return map[history.method];
};

/**
 * Description
 * @param {History[]} histories
 * @returns {null}
 */
const addSearchedField = (histories) => {
  histories.forEach((history) => {
    const shownText = [
      isoToFormatDate(history.createdAt, "yyyy/MM/dd HH:mm"),
      getMethodText(history),
    ];

    history.searchedField = shownText.join(" ");
  });
};

export { getMethodText, addSearchedField };
